import { render, staticRenderFns } from "./miniGameOpTab.vue?vue&type=template&id=ed7848aa&lang=pug"
import script from "./miniGameOpTab.vue?vue&type=script&lang=js"
export * from "./miniGameOpTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports